import type { AccountNumber } from '../../generated-types';

const isDomesticAccountNumber = (accountNumber?: AccountNumber): boolean => {
    if (!accountNumber) return false;
    const withoutAlphabet = accountNumber.value.replace(/([a-zA-Z])/g, '');
    const onlyNums = accountNumber.value.replace(/[^\d]/g, '');
    return withoutAlphabet === accountNumber.value && onlyNums.length === 11;
};

export default isDomesticAccountNumber;
